import { AppliedDiscountsItem } from '@airship-platform/airship-proposal';
import { FlexBox } from '@airship-platform/jam-web/components';
import { useAppointmentProposalOptionModifiers } from '../../data-access/appointmentProposalOptionModifiers';
import { useAppointmentProposalOptions } from '../../data-access/appointmentProposalOptions';

const AppliedDiscountsList: React.FC = () => {
  const { currentOption } = useAppointmentProposalOptions();
  const {
    proposalModifiers,
    isLoading,
    deleteAppointmentProposalOptionModifier,
  } = useAppointmentProposalOptionModifiers();

  const discounts = proposalModifiers.filter(
    (proposalModifier) =>
      proposalModifier.modifierType === 'DISCOUNT' &&
      proposalModifier.appointmentProposalOptionId ===
        currentOption?.appointmentProposalOptionId
  );

  if (!currentOption || !discounts.length) {
    return null;
  }

  const isReadOnly = currentOption.isReadOnly;

  const handleDelete = (optionModifierId: string) =>
    deleteAppointmentProposalOptionModifier(
      currentOption.appointmentId,
      currentOption.appointmentProposalId,
      currentOption.appointmentProposalOptionId,
      optionModifierId
    );

  return (
    <FlexBox gap={3} flexWrap={'wrap'}>
      {discounts.map((optionModifier) => (
        <AppliedDiscountsItem
          key={optionModifier.appointmentProposalOptionModifierId}
          displayName={optionModifier.displayName || 'Discount'}
          disabled={isLoading || isReadOnly}
          onClick={() =>
            handleDelete(optionModifier.appointmentProposalOptionModifierId)
          }
        />
      ))}
    </FlexBox>
  );
};
export default AppliedDiscountsList;
